"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@material-ui/core");
exports.default = () => core_1.createStyles({
    root: {
        fill: 'currentColor',
        display: 'inline-block',
        fontSize: 'inherit',
        height: '1em',
        verticalAlign: '-.125em'
    }
});
//# sourceMappingURL=styles.js.map